import ReactDOMServer from 'react-dom/server';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { startCase, sumBy } from 'lodash';
import React, { FC } from 'react';
import { getChartColor } from 'wb-reddit/app/routes/superGrid/actionRow/charts/utils';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { ChartTooltip } from '@aleph/shared-components';
import { captureException } from '@sentry/react';

type ColumnChartProps = {
	chartData: {
		kpi: number,
		breakdown: string,
	}[]
};

const RedditDashboardPieChart: FC<ColumnChartProps> = ({ chartData }) => {
	const total = sumBy(chartData, 'kpi');

	return (
		<div className="gap-[10px] flex items-center overflow-hidden">
			<HighchartsReact
				highcharts={Highcharts}
				options={{
					accessibility: {
						enabled: false,
					},
					plotOptions: {
						pie: {
							dataLabels: { enabled: false },
							innerSize:  '66%',
							states:     { hover: { halo: { size: 2 } } },
						},
					},
					tooltip: {
						shape:           'square',
						backgroundColor: 'transparent',
						borderWidth:     0,
						distance:        0,
						shadow:          false,
						useHTML:         true,
						outside:         true,
						className:       'super-grid-chart-tooltip',
						formatter() {
							try {
								return ReactDOMServer.renderToStaticMarkup(
									<ChartTooltip {...this}/>,
								);
							} catch (e) {
								captureException(e);

								return '';
							}
						},
					},
					chart: {
						spacing:             -8,
						width:               58,
						height:              58,
						type:                'pie',
						plotBackgroundColor: null,
						plotBorderWidth:     null,
						plotShadow:          false,
						allowPointSelect:    false,
						backgroundColor:     null,
					},
					credits: {
						enabled: false,
					},
					title:  undefined,
					series: [{
						type:         'pie',
						colorByPoint: true,
						animation:    false,
						data:         chartData?.map((stat, idx) => ({
							color: getChartColor({ idx, level: RedditLevel.AD_ACCOUNT, count: chartData.length }, true),
							name:  startCase(stat?.breakdown?.toLowerCase?.()),
							y:     ((stat?.kpi ?? 0) / total) * 100,
						})) ?? [],
					}],
				}}
			/>
			<div className="flex-1 overflow-hidden">
				{chartData?.map((stat, idx) => (
					<div
						className="text-[11px] leading-none py-[2px] overflow-hidden overflow-ellipsis"
						style={{
							color: getChartColor({ idx, level: RedditLevel.AD_ACCOUNT, count: chartData.length }, true),
						}}
						key={idx}
					>
						{startCase(stat?.breakdown?.toLowerCase?.())}
					</div>
				))}
			</div>
		</div>
	);
};

export default RedditDashboardPieChart;
